module.exports = "/assets/data/c63e271a7ef7ea9ff08f4616becd129f-B3.data.json";